import Marionette from "backbone.marionette";
import LegendView from "../views/report-legend";
import MessageModel from "../models/alert-message";

class ReportLegend extends Marionette.Behavior {
  defaults() {
    return {
      region: "legend",
      type: "warning",
    };
  }

  // custom event triggered by layout children views
  onReportLegend(message) {
    // grab the region
    const region = this.view.getRegion(this.options.region);
    if (region) {
      // create the model
      const model = new MessageModel({
        type: this.options.type,
        message,
      });

      // validate it
      if (model.isValid()) {
        // inject view into region
        region.show(
          new LegendView({
            model,
          })
        );
      }
    }
  }
}

export { ReportLegend as default };
